import React from 'react';
import { useEmbedFilters } from './EmbedWrapper';
import { useKPIData } from '../../hooks/useEmbedData';
import { OverallPerformanceWidget } from '../widgets/OverallPerformanceWidget';
import { KPICardWidget, KPICardId } from '../widgets/KPICardWidget';

interface EmbedOverallPerformanceProps {
  widget?: string;
}

const VALID_CARD_IDS: KPICardId[] = [
  'budget-total-month',
  'budget-as-of-yesterday',
  'actual-as-of-yesterday',
  'budget-billable-rate',
  'billable-rate-so-far',
];

const EmbedOverallPerformance: React.FC<EmbedOverallPerformanceProps> = ({ widget }) => {
  const filters = useEmbedFilters();
  const { data, isLoading, error } = useKPIData(filters);

  if (error) {
    return <div className="text-red-600 text-center py-4">Error: {error}</div>;
  }

  const kpiMetrics = data || {
    budgetTotalMonth: 0,
    budgetAsOfYesterday: 0,
    actualAsOfYesterday: 0,
    billableRateSoFar: 0,
    budgetBillableRate: 0,
    expectedTotalHours: 0,
    loggedTotalHours: 0,
    absence: 0,
    vacation: 0,
  };

  if (widget) {
    if (!VALID_CARD_IDS.includes(widget as KPICardId)) {
      return <div className="text-gray-600 text-center py-4">Unknown widget: {widget}</div>;
    }
    return <KPICardWidget cardId={widget as KPICardId} kpiMetrics={kpiMetrics} isLoading={isLoading} />;
  }

  return <OverallPerformanceWidget kpiMetrics={kpiMetrics} isLoading={isLoading} />;
};

export default EmbedOverallPerformance;
